<template>

    <div>

        <alert :closable="true" icon="info-circle" title="Info">
            <lang labelKey="APOPOINT-CC-INFO_BOX_TEXT"></lang>
        </alert>

        <div class="pharmacySelector" v-if="!isLoadingPharmacies">

            <form-input inputType="select" :showLabel="false" label="PHARMACY" v-model="pharmacySelected"
                selectFieldName="name" :selectIsSearchable="true" :selectAllowEmpty="true" :selectOptions="pharmacies"
                :showLabelInOptions="false">
            </form-input>
        </div>

        <loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

            <div class="wordpressContainer">

                <div>
                    <div>Wordpress v{{ wordpressInfo.version }}</div>

                    <template v-if="pharmacySelected">

                        <pop-confirm v-if="wordpressInfo.updateAvailable"
                            :content="$t('APOPOINT-CC-CONFIRM_UPDATE_TEXT')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="aktualsieren" :on-ok="function () { wordpressUpdate() }">
                            <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]">
                                <span class="material-symbols-outlined">upgrade</span> Aktualisieren auf {{
                                    wordpressInfo.updateAvailable }}
                            </button>
                        </pop-confirm>
                        <tag v-else size="small" type="success"><span class="material-symbols-outlined">check</span>
                        </tag>

                    </template>

                    <template v-else>

                        <div v-if="wordpressInfo.updateAvailable">Aktualisierung vorhanden v{{
                            wordpressInfo.updateAvailable }}</div>

                        <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_UPDATE_TEXT')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="aktualsieren" :on-ok="function () { wordpressUpdate() }">
                            <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]">
                                <span class="material-symbols-outlined">upgrade</span> Aktualisieren
                            </button>
                        </pop-confirm>

                    </template>

                </div>

                <div>

                    <div>{{ themeInfo.name }} v{{ themeInfo.version }}</div>

                    <template v-if="pharmacySelected">

                        <pop-confirm v-if="themeInfo.updateAvailable"
                            :content="$t('APOPOINT-CC-CONFIRM_UPDATE_TEXT-SINGLE')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="aktualsieren" :on-ok="function () { themeUpdate() }">
                            <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]">
                                <span class="material-symbols-outlined">upgrade</span> Aktualisieren auf {{
                                    themeInfo.updateAvailable }}
                            </button>
                        </pop-confirm>
                        <tag v-else size="small" type="success"><span class="material-symbols-outlined">check</span>
                        </tag>
                    </template>

                    <template v-else>

                        <div v-if="themeInfo.updateAvailable">Aktualisierung vorhanden v{{ themeInfo.updateAvailable }}
                        </div>

                        <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_UPDATE_TEXT')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="aktualsieren"
                            :on-ok="function () { themeUpdate(themeInfo) }">
                            <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]">
                                <span class="material-symbols-outlined">upgrade</span> Aktualisieren
                            </button>
                        </pop-confirm>

                    </template>

                </div>


                <div>

                    <div>Sprachdateien</div>

                    <template v-if="pharmacySelected">

                        <pop-confirm v-if="languagesInfo.updateAvailable"
                            :content="$t('APOPOINT-CC-CONFIRM_UPDATE_TEXT-SINGLE')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="aktualsieren" :on-ok="function () { languageUpdate() }">
                            <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]">
                                <span class="material-symbols-outlined">upgrade</span> Aktualisieren
                            </button>
                        </pop-confirm>
                        <tag v-else size="small" type="success"><span class="material-symbols-outlined">check</span>
                        </tag>
                    </template>

                    <template v-else>

                        <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_UPDATE_TEXT')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="aktualsieren" :on-ok="function () { languageUpdate() }">
                            <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]">
                                <span class="material-symbols-outlined">upgrade</span> Aktualisieren
                            </button>
                        </pop-confirm>

                    </template>

                </div>

                <div>

                    <div>Plugins Auto Updates</div>
                    <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_UPDATE_TEXT')" icon="question-circle-o"
                        cancel-text="abbrechen" ok-text="aktualsieren"
                        :on-ok="function () { disablePluginsAutoUpdates() }">
                        <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]">
                            <span class="material-symbols-outlined">update_disabled</span> alle deaktivieren
                        </button>
                    </pop-confirm>

                </div>

            </div>



        </template>

        <template v-if="!isLoading">

            <!--
            <lang labelKey="SELECT_BOX-PHARMACY-PLEASE_SELECT"></lang>
            <br><lang labelKey="APOPOINT-CC-CONFIRM_AUTO_UPDATE_OFF"></lang>
            <br><lang labelKey="APOPOINT-CC-CONFIRM_AUTO_UPDATE_ON"></lang>
            <br><lang labelKey="APOPOINT-CC-CONFIRM_UPDATE_TEXT"></lang>
            <br><lang labelKey="APOPOINT-CC-CONFIRM_ACTIVATE_TEXT"></lang>
            <br><lang labelKey="APOPOINT-CC-CONFIRM_DEACTIVATE_TEXT"></lang>
            -->



            <v-client-table ref="tblPlugins" name="tblPlugns" :key="pharmacySelected" :data="table.data"
                :columns="table.columns" :options="table.options" class="noFirstColumn">

                <template slot="updateAvailable" slot-scope="props">

                    <template v-if="props.row.updateAvailable">

                        <template v-if="siteId">

                            <pop-confirm :content="$t('APOPOINT-CC-SINGLE-CONFIRM_UPDATE_TEXT')"
                                icon="question-circle-o" cancel-text="abbrechen" ok-text="aktualsieren"
                                :on-ok="function () { pluginUpdate(props.row) }">
                                <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]"
                                    style="display: flex; align-items: center;" title="Klick für Aktualisierung">
                                    <span class="material-symbols-outlined">upgrade</span> v{{ props.row.updateAvailable
                                    }}
                                </button>
                            </pop-confirm>

                        </template>

                        <template v-else>

                            <tag type="success" size="small">
                                v{{ props.row.updateAvailable }}
                            </tag>

                        </template>

                    </template>

                </template>


                <template slot="autoUpdates" slot-scope="props">

                    <div style="display: flex; flex-wrap: wrap; gap: 3px 6px;">

                        <template v-if="!pharmacySelected">

                            <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_AUTO_UPDATE_ON')" icon="question-circle-o"
                                cancel-text="abbrechen" ok-text="aktualsieren"
                                :on-ok="function () { pluginAutoUpdateOn(props.row) }">
                                <button :class="['button is-default is-small', { 'is-loading': isUpdating }]">
                                    <span class="material-symbols-outlined">update</span> Aktivieren
                                </button>
                            </pop-confirm>

                            <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_AUTO_UPDATE_OFF')" icon="question-circle-o"
                                cancel-text="abbrechen" ok-text="aktualsieren"
                                :on-ok="function () { pluginAutoUpdateOff(props.row) }">
                                <button :class="['button is-default is-small', { 'is-loading': isUpdating }]">
                                    <span class="material-symbols-outlined">update_disabled</span> Deaktivieren
                                </button>
                            </pop-confirm>

                        </template>

                        <template v-else>

                            <b-switch v-model="props.row.autoUpdateEnabled" :key="props.row.id"
                                :on-change="function () { pluginAutoUpdateToggle(props.row) }" type="is-info"
                                passive-type="is-light" size="small"></b-switch>

                        </template>

                    </div>

                </template>

                <template slot="activation" slot-scope="props">

                    <b-switch v-model="props.row.active" :key="props.row.id"
                        :on-change="function () { pluginActivateToggle(props.row) }" type="is-info"
                        passive-type="is-light" size="small"></b-switch>

                </template>

                <template slot="actions" slot-scope="props">

                    <div style="display: flex; flex-wrap: wrap; gap: 3px 6px;">

                        <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_UPDATE_TEXT')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="aktualsieren"
                            :on-ok="function () { pluginUpdate(props.row) }">
                            <button :class="['button is-blue is-small update', { 'is-loading': isUpdating }]">
                                <span class="material-symbols-outlined">upgrade</span> Aktualisieren
                            </button>
                        </pop-confirm>

                        <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_ACTIVATE_TEXT')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="aktivieren"
                            :on-ok="function () { pluginActivate(props.row) }">
                            <button :class="['button is-small activate', { 'is-loading': isActivating }]">
                                <span class="material-symbols-outlined">check</span> Aktivieren
                            </button>
                        </pop-confirm>

                        <pop-confirm :content="$t('APOPOINT-CC-CONFIRM_DEACTIVATE_TEXT')" icon="question-circle-o"
                            cancel-text="abbrechen" ok-text="deaktivieren"
                            :on-ok="function () { pluginDeactivate(props.row) }">
                            <button :class="['button is-small deactivate', { 'is-loading': isDeactivating }]">
                                <span class="material-symbols-outlined">unpublished</span> Deaktivieren
                            </button>
                        </pop-confirm>
                    </div>

                </template>

            </v-client-table>

        </template>

        <!-- MODAL -->
        <modal width="640" transition="fadeDown" cancel-text="Abbrechen" :show-ok="false" :title="modal.title"
            :backdrop-closable="false" :is-show="modal.show" @close="closeModal">

            <template v-if="modal.isLoading || !progressStatus">
                <loading-indicator></loading-indicator>
            </template>

            <template v-else>


                <template v-if="progressStatus.progress != 1">

                    <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.message }}</div>
                    <progress-bar :percent="progressStatus.progress * 100" :showinfo="false" :striped="true"
                        :animated="true" size="large"></progress-bar>

                </template>

                <template v-else>

                    <div class="notification is-success" style="display: flex; gap: 0 12px; align-items: center;">
                        <span class="icon"><i class="fa fa-check"></i></span>
                        <span v-html="modal.successMsg"></span>
                    </div>


                    <div slot="footer">

                        <span :class="['button', { 'is-disabled': modal.isSaving || modal.isLoading }]"
                            @click="closeModal">schließen</span>

                    </div>

                </template>

            </template>

        </modal>





    </div>
</template>


<script>
import Vue from 'vue';
import { ClientTable } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

    components: {

    },

    data() {

        return {
            isLoading: true,
            isLoadingPharmacies: true,

            pharmacies: [],
            pharmacySelected: null,

            refreshIntervalId: null,
            progressStatus: null,

            modal: {
                show: false,
                title: '',
                successMsg: '',
                isLoading: false,
                isSaving: false,
            },


            wordpressInfo: null,
            themeInfo: null,
            languagesInfo: null,

            table: {
                data: [],
                columns: [],
                options: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 25,
                    orderBy: {
                        column: 'name',
                        ascending: true,
                    },

                    columnsClasses: { version: 'version', updateAvailable: 'updates', actions: 'actions' },

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        name(h) {
                            return <lang labelKey="APOPOINT-CC-TBL_PLUGINS-NAME"></lang>
                        },
                        version(h) {
                            return <lang labelKey="APOPOINT-CC-TBL_PLUGINS-VERSION"></lang>
                        },
                        updateAvailable(h) {
                            return <lang labelKey="APOPOINT-CC-TBL_PLUGINS-UPDATE_AVAILABLE"></lang>
                        },
                        autoUpdates() {
                            return <lang labelKey="APOPOINT-CC-TBL_PLUGINS-AUTO_UPDATES"></lang>
                        },
                        activation(h) {
                            return <lang labelKey="APOPOINT-CC-TBL_PLUGINS-ACTIVATION"></lang>
                        },
                        update(h) {
                            return <lang labelKey="APOPOINT-CC-TBL_PLUGINS-ACTIONS"></lang>
                        },
                    },

                    sortable: ['name'],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-up',
                        down: 'fa-sort-down',
                        is: 'fa-sort'
                    },

                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                }
            }
        }
    },



    created() {

        this.table.columns = this.columnsComputed;
        this.init();

    },

    computed: {

        siteId() {
            return this.pharmacySelected ? this.pharmacySelected.id : null;
        },

        columnsComputed() {
            return this.siteId
                ? ['name', 'version', 'updateAvailable', 'autoUpdates', 'activation']
                : ['name', 'version', 'updateAvailable', 'autoUpdates', 'actions'];

        }

    },

    methods: {

        buildRequestURL(urlPart) {

            let url = new URL(`${this.$config.api}apopoint/${urlPart}`);

            if (this.siteId) {
                url.searchParams.append('site', this.siteId);
            }

            return url;

        },

        async init(showLoadingState = true) {

            this.isLoading = showLoadingState;

            try {

                if (this.pharmacies.length == 0) {
                    await this.getPharmacies();
                }

                let url = `${this.$config.api}apopoint/info`;
                if (this.siteId) {
                    url += `?site=${this.siteId}`;
                }
                const res = await this.axios.get(url);
                if (res.data.error) {
                    throw new Error(res.data.error);
                }

                this.table.data = res.data.plugins;
                this.wordpressInfo = res.data.wordpress;
                this.themeInfo = res.data.theme;
                this.languagesInfo = res.data.languages;

            }

            catch (err) {
                console.log(err.message);
                this.pharmacySelected = null;
                this.$notify.open({ content: `FEHLER: ${err.message}`, type: 'warning' });
            }
            finally {
                this.isLoading = false;
                this.$forceUpdate();
            }


        },

        async getPharmacies() {

            this.isLoadingPharmacies = true;

            const pharmacies = await this.axios.get(this.$config.api + 'site?filters[hasApoPoint]=1&orderBy=name');
            this.pharmacies = pharmacies.data.site;

            this.isLoadingPharmacies = false;

        },

        async pluginUpdate(plugin) {

            let url = this.buildRequestURL(`updatePlugin?plugin=${plugin.id}`);

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress(plugin, res.data.key, 'update');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }

        },

        async pluginAutoUpdateToggle(plugin) {

            if (!plugin.autoUpdateEnabled) {
                this.pluginAutoUpdateOff(plugin);
            } else {
                this.pluginAutoUpdateOn(plugin);
            }

        },

        async pluginAutoUpdateOn(plugin) {

            let url = this.buildRequestURL(`enablePluginAutoUpdate?plugin=${plugin.id}`);

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress(plugin, res.data.key, 'pluginAutoUpdateOn');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }

        },

        async pluginAutoUpdateOff(plugin) {

            let url = this.buildRequestURL(`disablePluginAutoUpdate?plugin=${plugin.id}`);

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress(plugin, res.data.key, 'pluginAutoUpdateOff');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }

        },

        async pluginActivateToggle(plugin) {

            if (!plugin.active) {
                this.pluginDeactivate(plugin);
            } else {
                this.pluginActivate(plugin);
            }

        },

        async pluginActivate(plugin) {

            let url = this.buildRequestURL(`activatePlugin?plugin=${plugin.id}`);

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress(plugin, res.data.key, 'activate');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }

        },

        async pluginDeactivate(plugin) {

            let url = this.buildRequestURL(`deactivatePlugin?plugin=${plugin.id}`);

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress(plugin, res.data.key, 'deactivate');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }


        },

        async wordpressUpdate(plugin) {

            let url = this.buildRequestURL(`updateCore`);

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress({ name: 'Wordpress' }, res.data.key, 'updateCore');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }

        },

        async themeUpdate(plugin) {

            let url = this.buildRequestURL(`updateTheme`);

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress(plugin, res.data.key, 'updateTheme');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }

        },

        async languageUpdate() {

            let url = this.buildRequestURL(`updateLanguages`)

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress({ name: 'Sprachdateien' }, res.data.key, 'updateLanguages');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }

        },

        async disablePluginsAutoUpdates() {

            let url = this.buildRequestURL(`disablePluginsAutoUpdates`)

            try {
                const res = await this.axios.post(url);
                if (!res || res.data.error) {
                    throw new Error(res.data.error);
                }
                this.startProgress({ name: 'Sprachdateien' }, res.data.key, 'disablePluginsAutoUpdates');
            }
            catch (e) {
                this.$notify.open({ content: e.message, type: 'warning' });
                console.error(e.message);
            }

        },



        async startProgress(plugin, key, type) {

            switch (type) {

                case "activate":
                    this.modal.title = `Aktiviere ${plugin.name}`;
                    this.modal.successMsg = "Plugin wurde erfolgreich aktiviert";
                    break;

                case "deactivate":
                    this.modal.title = `Deaktiviere ${plugin.name}`;
                    this.modal.successMsg = `Plugin "${plugin.name}" wurde erfolgreich deaktiviert`;
                    break;

                case "update":
                    this.modal.title = `Aktualisiere ${plugin.name}`;
                    this.modal.successMsg = `Das Plugin "${plugin.name}" wurde erfolgreich aktualisiert`;
                    break;

                case "pluginAutoUpdateOn":
                    this.modal.title = `Aktualisiere Auto-Update Einstellungen für ${plugin.name}`;
                    this.modal.successMsg = `Automatische Aktualisierunge für das Plugin "${plugin.name}"" wurde <b>aktiviert</b>`;
                    break;

                case "pluginAutoUpdateOff":
                    this.modal.title = `Aktualisiere Auto-Update Einstellungen für ${plugin.name}`;
                    this.modal.successMsg = `Automatische Aktualisierung für das Plugin "${plugin.name}" wurde <b>deaktiviert</b>`;
                    break;

                case "updateTheme":
                    this.modal.title = `Aktualisiere ${plugin.name}`;
                    this.modal.successMsg = `Das Theme "${plugin.name}" wurde erfolgreich aktualisiert`;
                    break;

                case "updateLanguages":
                    this.modal.title = `Aktualisiere ${plugin.name}`;
                    this.modal.successMsg = `${plugin.name} wurden erfolgreich aktualisiert`;
                    break;

                case "updateCore":
                    this.modal.title = `Aktualisiere Wordpress`;
                    this.modal.successMsg = "Wordpress wurde erfolgreich aktualisiert";
                    break;

                case "disablePluginsAutoUpdates":
                    this.moda
                    this.modal.title = `Auto-Updates für Plugins deaktivieren`;
                    this.modal.successMsg = "Die automatische Aktualisierung für Plugins wurde deaktiviert";
                    break;

            }


            this.modal.show = true;

            this.refreshIntervalId = setInterval(() => {

                this.axios.get(this.$config.api + `apopoint/progress?key=${key}`).then((res) => {
                    this.progressStatus = res.data;
                    if (res.data.progress === 1) {
                        clearInterval(this.refreshIntervalId);
                        this.init(false);
                    }
                })

            }, 1000);

        },

        closeModal() {

            // in case we've running an interval
            clearInterval(this.refreshIntervalId);

            this.progressStatus = null;

            this.modal.successMsg = "";
            this.modal.title = "";
            this.modal.isSaving = false;
            this.modal.show = false;

        },
    },

    watch: {

        pharmacySelected(val) {
            // console.log("VAL: ", val);
            this.table.columns = this.columnsComputed;
            this.init(true);
        }

    }


}

</script>

<style lang="scss" scoped>
@import '~../../../assets/css/variables.scss';

button {
    border-radius: 4px !important;
    color: #FFF;
    transition: all .3s ease;

    &:hover,
    &:focus {
        color: #FFF;
    }

    &.is-default {
        // background-color: $themeColor1;
        background-color: #F1F1F1;
        color: #222;
    }

    &.activate {
        background-color: #6cc788;

        &:hover {
            background-color: #5ca772
        }
    }

    &.deactivate {
        background-color: rgb(187, 102, 102);

        &:hover {
            background-color: rgb(148, 79, 79);
        }
    }

}

.wordpressContainer {
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: center;
    gap: 12px;
    margin-bottom: 20px;

    >div {
        background-color: #f1f1f1;
        padding: 18px 28px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
        min-height: 90px;
    }
}

.pharmacySelector {
    background-color: #f1f1f1;
    padding: 12px 16px;
    border-radius: 2px;
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: center;

    ::v-deep .control {
        min-width: 400px;
    }

    ::v-deep .control>.control {
        margin-bottom: 0;
    }

    .pharmacySelectorLabel {
        margin-bottom: 2px;
        text-transform: uppercase;
        font-size: 10px;
    }
}


::v-deep .VueTables {

    #VueTables_th--name {
        width: 500px;
        max-width: 500px;
    }

    #VueTables_th--version {
        width: 100px;
        max-width: 100px;
    }

    /*
    #VueTables_th--updateAvailable {
        width: 85px;
        max-width: 85px;
    }
    */
    #VueTables_th--actions {
        width: 300px;
        max-width: 300px;
    }

    #VueTables_th--autoUpdates {
        width: 200px;
        max-width: 200px;
    }

    #VueTables_th--activation {
        width: 150px;
        max-width: 150px;
    }
}
</style>
